import cx from 'classnames';
import styles from './CustomerAccountEquipmentActionWrapper.module.scss';
import { CustomerAccountEquipmentActionWrapperProps } from '../types';

export const CustomerAccountEquipmentActionWrapper = ({
  classname,
  children
}: CustomerAccountEquipmentActionWrapperProps) => {
  return (
    <div className={cx(styles['action-card-container'], classname)}>
      {children}
    </div>
  );
};

export default CustomerAccountEquipmentActionWrapper;
